var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"animation"}},[(_vm.visable)?_c('div',{staticClass:"loaidng",style:({background:_vm.background})},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }